import { LanguageInfo } from '@abp/ng.core';

export function resolveLanguage(input: string, supportedLanguages: LanguageInfo[]): string {
  const exact = supportedLanguages.find(x => x.uiCultureName === input);
  if (exact) return exact.uiCultureName;
  const twoLetter = input.split('-')[0];
  const partial = supportedLanguages.find(x => x.uiCultureName.split('-')[0] === twoLetter);
  if (partial) return partial.uiCultureName;
  return 'en';
}
